import React, { useState } from 'react'
import './index.css'
import { PlanPositionStage } from '../../types'

type Props = {
    stage: PlanPositionStage
    edit: number | null
    ready: number | null
    sent: number | null
    onTabChange: (stage: PlanPositionStage) => void
    onTabClick: (selectAllFlag: boolean) => void
    theme: string
}

const PlanPositionsTabs: React.FC<Props> = ({
    stage,
    edit,
    ready,
    sent,
    onTabClick,
    onTabChange,
    theme,
}) => {
    return (
        <div className="flex flex-row ">
            <div className="w-5"></div>
            {Object.values(PlanPositionStage).map((item, index) => {
                return (
                    <div
                        key={index}
                        className={`cursor-pointer ${
                            stage == item
                                ? 'w-60 h-7 content-center rounded-t-[10px] text-center text-sm text-[#181818] bg-[#f0f3f5] dark:bg-[#181818] dark:text-[#FFFFFF]'
                                : 'w-60 h-7 content-center rounded-t-[10px] text-center text-xs hover:text-sm text-[#6A6A6A] dark:text-[#8A8A8A] hover:text-[#181818] hover:bg-[#f0f3f5] dark:hover:bg-[#181818] dark:hover:text-[#FFFFFF]'
                        }`}
                        onClick={() => {
                            onTabChange(item)
                            onTabClick(false)
                        }}
                    >
                        <div className="flex flex-row w-full h-full items-center justify-center gap-2">
                            {item}

                            {index == 0 ? (
                                edit ? (
                                    <div className="flex w-fit px-2 rounded-full items-center justify-center text-[12.8px] text-[#181818] bg-[#cccccc] dark:text-[#FFFFFF] dark:bg-[#333033]">
                                        {edit}
                                    </div>
                                ) : (
                                    ''
                                )
                            ) : index == 1 ? (
                                ready ? (
                                    <div className="flex w-fit px-2 rounded-full items-center justify-center text-[12.8px] text-[#181818] bg-[#cccccc] dark:text-[#FFFFFF] dark:bg-[#333033]">
                                        {ready}
                                    </div>
                                ) : (
                                    ''
                                )
                            ) : index == 2 ? (
                                sent ? (
                                    <div className="flex w-fit px-2 rounded-full items-center justify-center text-[12.8px] text-[#181818] bg-[#cccccc] dark:text-[#FFFFFF] dark:bg-[#333033]">
                                        {sent}
                                    </div>
                                ) : (
                                    ''
                                )
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default PlanPositionsTabs
